// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"0d0cf9ba","453":"d5da39d2"}[chunkId] + ".chunk.js";
};